<ng-template #resetDateContent >
  <app-reset-date
    [dateSelected]="!!dateSelected"
    [resetDisabled]="changeDateDisabled"
    (resetDate)="resetExpectedProjectDate()"
  ></app-reset-date>
</ng-template>

<div [ngClass]="{'display-flex':!itemsAlignedVertically}">
  <div class="display-flex align-items-center"
    [ngClass]="{'pr-1':!itemsAlignedVertically}">
    <b>
      {{ dateSelected | date:'mediumDate':undefined:'de-CH' }}
    </b>
    @if (itemsAlignedVertically) {
      <ng-template [ngTemplateOutlet]="resetDateContent"></ng-template>
    }
  </div>
  <div class="cursor-pointer calendar-icon-container bg-light-blue"
    [ngClass]="{'mx-2':!itemsAlignedVertically, 'pointer-events-none opacity-6': changeDateDisabled}"
    (click)="openSelectDateDialog()">
    <img
      src="/assets/images/calendar.svg" alt="Choose date">
    </div>
    <div
      class="modal fade modal-project" data-backdrop="static" tabindex='-1'
      #selectDateModal>
      <div class="modal-dialog modal-dialog-centered choose-date-modal">
        <div class="modal-content border-radius-0">
          <div class="modal-header text-uppercase font-size-16">
            <div class="modal-title">
              <ng-container i18n="@@app.choose_date">Choose date</ng-container>
            </div>
            <div #tooltipElement class="tooltip cursor-pointer position-initial mx-1">
              <span
              class="cheatSheetIcon se-icon-information_stroke info-icon font-size-18 cursor-pointer"></span>
              <span class="tooltip-text tooltip-right w-50 text-left font-size-xs position-absolute px-2 py-1">
                <ng-container
                i18n="@@app.expected_date_of_first_delivery">Expected date of first delivery (e.g. enclosures) does not replace the official order and is used exclusively for forecasts to reduce delivery times.</ng-container>
              </span>
            </div>
            <button type="button" (click)="closeModal(); $event.stopPropagation()" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body p-0 display-flex calendar-container">
            @for (number of calendars; track number) {
              <mat-calendar
                class="calendar px-1"
                [ngClass]="{'disable-change-month-buttons' : number > 0}"
                [startAt]="todayDate | dateFromMonth : number"
                [selected]="dateSelected"
                [maxDate]="maxDate"
                [minDate]="todayDate"
                [headerComponent]="number > 0 ? customCalendarHeader : null"
                (selectedChange)="selectDate($event)">
              </mat-calendar>
            }
          </div>
        </div>
      </div>
    </div>
    @if (!itemsAlignedVertically) {
      <ng-template [ngTemplateOutlet]="resetDateContent"></ng-template>
    }
  </div>
